var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Blocks',{staticClass:"disclaimer",attrs:{"blocks":_vm.config,"customComponents":_vm.customComponents}})
}
var staticRenderFns = []

export { render, staticRenderFns }